export type DomainType = 'rfw_subdomain' | 'custom_domain';

export type DomainStatus = 'active' | 'pending_verification' | 'expired' | 'suspended';

export interface PremiumDomain {
  id: number;
  radioName: string;
  radioId: number;
  frequency: string;
  plan: string;
  redirectCode: string;
  domainType: DomainType;
  domain: string;
  status: DomainStatus;
  assignedAt: string;
  expiresAt: string;
  verifiedAt: string | null;
  dnsStatus: 'ok' | 'pending' | 'error' | null;
  sslEnabled: boolean;
  previousDomains: string[];
}

export const premiumDomainsData: PremiumDomain[] = [
  {
    id: 1,
    radioName: 'Radio Nueva Actitud',
    radioId: 101,
    frequency: '94.70 RFW',
    plan: 'Empresarial',
    redirectCode: 'nueva-actitud',
    domainType: 'custom_domain',
    domain: 'nuevaactitud.com',
    status: 'active',
    assignedAt: '2025-11-15',
    expiresAt: '2027-11-15',
    verifiedAt: '2025-11-18',
    dnsStatus: 'ok',
    sslEnabled: true,
    previousDomains: ['nuevaactitud.rfw.fm'],
  },
  {
    id: 2,
    radioName: 'Radio Ritmo Latino',
    radioId: 102,
    frequency: '101.30 RFW',
    plan: 'Oro',
    redirectCode: 'ritmo-latino',
    domainType: 'rfw_subdomain',
    domain: 'ritmolatino.rfw.fm',
    status: 'active',
    assignedAt: '2026-01-20',
    expiresAt: '2027-01-20',
    verifiedAt: '2026-01-20',
    dnsStatus: null,
    sslEnabled: true,
    previousDomains: [],
  },
  {
    id: 3,
    radioName: 'Radio Éxitos TV',
    radioId: 103,
    frequency: '94.70 RFW',
    plan: 'Empresarial',
    redirectCode: 'exitos-tv',
    domainType: 'custom_domain',
    domain: 'exitostv.net',
    status: 'active',
    assignedAt: '2025-09-05',
    expiresAt: '2027-09-05',
    verifiedAt: '2025-09-08',
    dnsStatus: 'ok',
    sslEnabled: true,
    previousDomains: ['exitostv.rfw.fm', 'exitostv.com'],
  },
  {
    id: 4,
    radioName: 'Radio Fiesta Mix',
    radioId: 104,
    frequency: '88.50 RFW',
    plan: 'Pro',
    redirectCode: 'fiesta-mix',
    domainType: 'rfw_subdomain',
    domain: 'fiestamix.rfw.fm',
    status: 'active',
    assignedAt: '2026-03-10',
    expiresAt: '2027-03-10',
    verifiedAt: '2026-03-10',
    dnsStatus: null,
    sslEnabled: true,
    previousDomains: [],
  },
  {
    id: 5,
    radioName: 'Radio Sonora Digital',
    radioId: 106,
    frequency: '103.70 RFW',
    plan: 'Oro',
    redirectCode: 'sonora-digital',
    domainType: 'custom_domain',
    domain: 'sonoradigital.com',
    status: 'pending_verification',
    assignedAt: '2026-06-14',
    expiresAt: '2027-06-14',
    verifiedAt: null,
    dnsStatus: 'pending',
    sslEnabled: false,
    previousDomains: [],
  },
  {
    id: 6,
    radioName: 'Radio Stereo Visión',
    radioId: 107,
    frequency: '96.10 RFW',
    plan: 'Empresarial',
    redirectCode: 'stereo-vision',
    domainType: 'rfw_subdomain',
    domain: 'stereovision.rfw.fm',
    status: 'active',
    assignedAt: '2025-08-01',
    expiresAt: '2027-08-01',
    verifiedAt: '2025-08-01',
    dnsStatus: null,
    sslEnabled: true,
    previousDomains: [],
  },
  {
    id: 7,
    radioName: 'Radio Clásica FM',
    radioId: 108,
    frequency: '88.90 RFW',
    plan: 'Oro',
    redirectCode: 'clasica-fm',
    domainType: 'custom_domain',
    domain: 'clasicafm.net',
    status: 'active',
    assignedAt: '2025-12-01',
    expiresAt: '2027-12-01',
    verifiedAt: '2025-12-04',
    dnsStatus: 'ok',
    sslEnabled: true,
    previousDomains: ['clasicafm.rfw.fm'],
  },
  {
    id: 8,
    radioName: 'Radio Urbana 101',
    radioId: 109,
    frequency: '101.10 RFW',
    plan: 'Empresarial',
    redirectCode: 'urbana-101',
    domainType: 'custom_domain',
    domain: 'urbana101.com',
    status: 'suspended',
    assignedAt: '2025-10-20',
    expiresAt: '2026-10-20',
    verifiedAt: '2025-10-23',
    dnsStatus: 'error',
    sslEnabled: false,
    previousDomains: [],
  },
  {
    id: 9,
    radioName: 'Radio Élite Digital',
    radioId: 110,
    frequency: '107.50 RFW',
    plan: 'Oro',
    redirectCode: 'elite-digital',
    domainType: 'rfw_subdomain',
    domain: 'elitedigital.rfw.fm',
    status: 'expired',
    assignedAt: '2024-06-01',
    expiresAt: '2025-06-01',
    verifiedAt: '2024-06-01',
    dnsStatus: null,
    sslEnabled: false,
    previousDomains: [],
  },
  {
    id: 10,
    radioName: 'La Voz del Llano',
    radioId: 102,
    frequency: '92.30 RFW',
    plan: 'Empresarial',
    redirectCode: 'voz-del-llano',
    domainType: 'custom_domain',
    domain: 'lavozdelllano.com',
    status: 'active',
    assignedAt: '2026-02-14',
    expiresAt: '2028-02-14',
    verifiedAt: '2026-02-18',
    dnsStatus: 'ok',
    sslEnabled: true,
    previousDomains: ['lavozdelllano.rfw.fm'],
  },
  {
    id: 11,
    radioName: 'Radio Universo Online',
    radioId: 112,
    frequency: '95.80 RFW',
    plan: 'Pro',
    redirectCode: 'universo-online',
    domainType: 'rfw_subdomain',
    domain: 'universoonline.rfw.fm',
    status: 'active',
    assignedAt: '2026-04-05',
    expiresAt: '2027-04-05',
    verifiedAt: '2026-04-05',
    dnsStatus: null,
    sslEnabled: true,
    previousDomains: [],
  },
  {
    id: 12,
    radioName: 'Radio Festival TV',
    radioId: 113,
    frequency: '100.20 RFW',
    plan: 'Empresarial',
    redirectCode: 'festival-tv',
    domainType: 'custom_domain',
    domain: 'festivaltv.net',
    status: 'active',
    assignedAt: '2025-07-10',
    expiresAt: '2027-07-10',
    verifiedAt: '2025-07-14',
    dnsStatus: 'ok',
    sslEnabled: true,
    previousDomains: ['festivaltv.rfw.fm', 'festivaltv.com'],
  },
];

export const authorizedPlans = ['Oro', 'Empresarial'];

export const dnsSetupGuide = {
  aRecord: { type: 'A', name: '@', value: '76.76.21.21' },
  cnameRecord: { type: 'CNAME', name: 'www', value: 'rfw.fm' },
  txtRecord: { type: 'TXT', name: '@', value: 'rfw-verify={code}' },
};

export function getDomainByCode(code: string): PremiumDomain | undefined {
  return premiumDomainsData.find((d) => d.redirectCode === code);
}

export function getDomainByRadioId(radioId: number): PremiumDomain | undefined {
  return premiumDomainsData.find((d) => d.radioId === radioId);
}